export const ETH_ADDRESS = "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2";
export const BNB_ADDRESS = "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c";
export const INFURA_API_KEY = "c588dc84381d43289c42699ae6ec2685";
export const ALCHEMY_API_KEY = "sgaC0taaUx2aP38ruOoR1dpkyeFCJb0t";
export const WALLET_CONNECT_ID ="c453da6437b7ad94ffe700095cb16325";
export const MORALIS_API_KEY =
  "Otq6LdQxuKWqnTr7655BhbTYmMk8oSwbfR3toYE1YNWjW7V1rhycI04pZ1FzBR6C";
